import { useQueryClient } from '@tanstack/react-query';
import { useMarkAllNotificationsAsRead } from './useMarkAllNotificationsAsRead';

export const useMarkAllNotifications = (refetch: () => void) => {
  const queryClient = useQueryClient();
  const markAllNotificationsAsReadMutation = useMarkAllNotificationsAsRead();

  const handleMarkAllAsRead = () => {
    markAllNotificationsAsRead();
  };

  const markAllNotificationsAsRead = () => {
    markAllNotificationsAsReadMutation.mutate(undefined, {
      onSuccess: () => {
        refetch();
        queryClient.invalidateQueries({ queryKey: ['notifications-count'] });
      },
    });
  };

  return { handleMarkAllAsRead };
};
